import {
  formatValueWithMiddlewares,
  checkForNA,
  createKpiTileItem,
  appendPercentage,
  formatNormalNumber,
} from '../../../../utils/helper';

export default {
  type: 'KpiTile',
  handler: (data) => {
    const { scenariosGenerated, scenariosGeneratedDelta } = data;

    return createKpiTileItem(
      'Scenarios Created',
      formatNormalNumber(scenariosGenerated),
      Number(scenariosGeneratedDelta) !== 0
        ? {
            isPositiveValue: scenariosGeneratedDelta > 0,
            text: formatValueWithMiddlewares(scenariosGeneratedDelta, [
              checkForNA,
              appendPercentage,
            ]).toString(),
            sideLabel: '',
            showArrow: scenariosGeneratedDelta !== 0,
          }
        : null
    );
  },
};
